export type FireSide = 'left' | 'right';
export type FireVariant = 'lantern' | 'doubleTap';
export type PlayerSpeed = 'brief' | 'fast';

export interface Settings {
  /** Bible §3 A/B: 'lantern' (variant A, button in the floor scenery) or 'doubleTap' (variant B). */
  fireVariant: FireVariant;
  /** Lantern side (variant A only). */
  fireSide: FireSide;
  /** Legacy virtual d-pad. Off by default. */
  dpad: boolean;
  sound: boolean;
  haptics: boolean;
  /** 'brief' = 5/6 ticks per cell from the brief; 'fast' = 4/5 (alternative for the open question). */
  playerSpeed: PlayerSpeed;
  /** Dev: draw from the sliced real art or the procedural placeholders (proves art drops in by name). */
  artSource: 'real' | 'placeholder';
  /** Dev A/B: closed sack (ART3_sack_closed) instead of the open one. */
  closedSack: boolean;
  /** A3: gems render half-buried until Pip's headlamp cone or an adjacent dig reveals them (render only). */
  gemDiscovery: boolean;
}

export const PLAYER_SPEEDS: Record<PlayerSpeed, { h: number; v: number; label: string }> = {
  brief: { h: 5, v: 6, label: 'Brief (5h / 6v ticks per cell)' },
  fast: { h: 4, v: 5, label: 'Fast (4h / 5v ticks per cell)' },
};

export const SETTINGS_KEY = 'proto.settings.v1';
const KEY = SETTINGS_KEY;

export const DEFAULT_SETTINGS: Settings = {
  fireVariant: 'lantern',
  fireSide: 'left',
  dpad: false,
  sound: true,
  haptics: true,
  playerSpeed: 'brief',
  artSource: 'real',
  closedSack: false,
  gemDiscovery: true,
};

export function loadSettings(): Settings {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const s = { ...DEFAULT_SETTINGS, ...(JSON.parse(raw) as Partial<Settings>) };
      if (s.fireVariant !== 'lantern' && s.fireVariant !== 'doubleTap') s.fireVariant = 'lantern';
      return s;
    }
  } catch {
    /* ignore */
  }
  return { ...DEFAULT_SETTINGS };
}

export function saveSettings(s: Settings): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(s));
  } catch {
    /* ignore */
  }
}
